import { Promotion } from '../../../../stores/promotion';
import style from '../../style.module.scss';

const renderActivationDates = (_: unknown, record: Promotion) => {
    const hasActivationPeriod = !!(
        record.activationReadyDate || record.deactivationDisplayDate
    );
    return (
        <div className={'dates_holder'} style={{ padding: '4px 0' }}>
            {hasActivationPeriod ? (
                <>
                    <div
                        className="text_center inline_block"
                        style={{ marginRight: '12px' }}
                    >
                        <div style={{ marginBottom: '2px' }}>
                            {record.activationReadyDate &&
                            record.activationReadyDate.format
                                ? record.activationReadyDate.format('ll')
                                : '-'}
                        </div>
                        <div className={'lil_label'}>
                            {record.activationReadyDate &&
                            record.activationReadyDate.format
                                ? record.activationReadyDate.format('LT')
                                : ''}
                        </div>
                    </div>
                    <div className="text_center inline_block">
                        <div style={{ marginBottom: '2px' }}>
                            {record.deactivationDisplayDate &&
                            record.deactivationDisplayDate.format
                                ? record.deactivationDisplayDate.format('ll')
                                : '-'}
                        </div>
                        <div className={'lil_label'}>
                            {record.deactivationDisplayDate &&
                            record.deactivationDisplayDate.format
                                ? record.deactivationDisplayDate.format('LT')
                                : ''}
                        </div>
                    </div>
                </>
            ) : (
                <div className={style.callout_info_subtle}>
                    Activation during complete visibility period
                </div>
            )}
        </div>
    );
};

export default renderActivationDates;
